import type { ProductRuntime } from "./productRuntime";

const visitorKey="fivek_attribution_visitor_v1";
const sessionKey="fivek_attribution_session_v1";
const touchKey=(slug:string)=>`fivek_attribution_touch_${slug}`;
const id=(storage:Storage,key:string)=>{let value=storage.getItem(key);if(!value){value=crypto.randomUUID();storage.setItem(key,value)}return value};
const visitorId=()=>id(localStorage,visitorKey);
const sessionId=()=>id(sessionStorage,sessionKey);
const channelCode=()=>{const query=new URLSearchParams(location.search);return query.get("channel")||query.get("cCode")||query.get("cid")||query.get("dc")||query.get("_c")||query.get("utm_source")||query.get("c")||"NATURAL"};
const platform=()=>/Android/i.test(navigator.userAgent)?"android":/iPhone|iPad|iPod/i.test(navigator.userAgent)?"ios":"web";
let activeAttribution="";

export const attribution={
  visitorId,sessionId,platform,channelCode,
  current:()=>activeAttribution||sessionStorage.getItem("fivek_attribution_current_v1")||"",
  async bootstrap(product:ProductRuntime){
    if(product.hostMode!=="landing")return "";
    const cached=sessionStorage.getItem(touchKey(product.slug));
    if(cached){activeAttribution=cached;return cached}
    try{
      const response=await fetch("/vdo-api/v2/attribution/touch",{method:"POST",credentials:"include",cache:"no-store",signal:AbortSignal.timeout(4000),headers:{"Content-Type":"application/json"},body:JSON.stringify({productSlug:product.slug,channelCode:channelCode(),visitorId:visitorId(),sessionId:sessionId(),platform:platform(),pageUrl:location.href,referer:document.referrer})});
      const body=await response.json();if(!response.ok||!body?.data?.attributionId)throw new Error("touch failed");
      activeAttribution=body.data.attributionId;sessionStorage.setItem(touchKey(product.slug),activeAttribution);sessionStorage.setItem("fivek_attribution_current_v1",activeAttribution);return activeAttribution;
    }catch{return ""}
  },
  async download(kind:"android"|"ios"){
    const attributionId=this.current();if(!attributionId)return false;
    try{return (await fetch("/vdo-api/v2/attribution/download",{method:"POST",credentials:"include",keepalive:true,headers:{"Content-Type":"application/json"},body:JSON.stringify({attributionId,platform:kind,visitorId:visitorId(),sessionId:sessionId()})})).ok}catch{return false}
  },
};
